import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import paymentTextContent from './paymentTextContent';

const { checkboxLabelText } = paymentTextContent;

export const formFields = {
  giftaid: {
    label: checkboxLabelText,
    id: 'giftaid',
    type: 'boolean',
  },
};

export const getRules = () => ({
  [formFields.giftaid.id]: yup.boolean(),
});

export const getFormSchema = () => (
  yup.object().shape(getRules())
);

export const getFormResolver = () => (
  yupResolver(getFormSchema())
);
